
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');

    if (facetForm) {
      facetForm.addEventListener('input', (event) => {
        /*
         * Kategorie-Tags sofort anwenden.
         *
         * Die Kategorie-Filter haben in facets.liquid
         * die Klasse "facets__disclosure--category".
         *
         * Dadurch wird für diese Filter der normale
         * 800ms-Debounce übersprungen.
         */
        if (event.target.closest('.facets__disclosure--category')) {
          this.onSubmitHandler(event);
          return;
        }

        /*
         * Alle anderen Filter behalten das ursprüngliche
         * Verhalten mit 800ms Debounce.
         */
        this.debouncedOnSubmit(event);
      });
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');

    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;

      if (searchParams === FacetFiltersForm.searchParamsPrev) return;

      FacetFiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;

    const sections = FacetFiltersForm.getSections();

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );

    /*
     * Spinner sofort anzeigen.
     *
     * Bei Kategorie-Tags passiert dieser Aufruf unmittelbar
     * nach dem Klick, da dort der 800ms-Debounce übersprungen wird.
     */
    loadingSpinners.forEach((spinner) => {
      spinner.classList.remove('hidden');
    });

    const productGridContainer = document.getElementById('ProductGridContainer');
    const collectionElement = productGridContainer
      ? productGridContainer.querySelector('.collection')
      : null;

    if (collectionElement) {
      collectionElement.classList.add('loading');
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }

    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error ${response.status}`);
        }

        return response.text();
      })
      .then((responseText) => {
        const html = responseText;

        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          {
            html,
            url
          }
        ];

        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(html.innerHTML);
        }
      })
      .catch((error) => {
        console.error('Facet filter request failed:', error);

        const loadingSpinners = document.querySelectorAll(
          '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );

        loadingSpinners.forEach((spinner) => {
          spinner.classList.add('hidden');
        });

        const productGridContainer = document.getElementById('ProductGridContainer');
        const collectionElement = productGridContainer
          ? productGridContainer.querySelector('.collection')
          : null;

        if (collectionElement) {
          collectionElement.classList.remove('loading');
        }

        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');

        if (countContainer) {
          countContainer.classList.remove('loading');
        }

        if (countContainerDesktop) {
          countContainerDesktop.classList.remove('loading');
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const cachedData = FacetFiltersForm.filterData.find(filterDataUrl);

    if (!cachedData) return;

    const html = cachedData.html;

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(html.innerHTML);
    }
  }

  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById('ProductGridContainer');

    if (!productGridContainer) return;

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newProductGridContainer = parsedHTML.getElementById('ProductGridContainer');

    if (!newProductGridContainer) return;

    productGridContainer.innerHTML = newProductGridContainer.innerHTML;

    productGridContainer
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCount');

    if (!countElement) return;

    const count = countElement.innerHTML;

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );

    loadingSpinners.forEach((spinner) => {
      spinner.classList.add('hidden');
    });

    const productGridContainer = document.getElementById('ProductGridContainer');
    const collectionElement = productGridContainer
      ? productGridContainer.querySelector('.collection')
      : null;

    if (collectionElement) {
      collectionElement.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server.
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event
        ? event.target.closest('.js-filter')
        : undefined;

      return jsFilter
        ? element.id === jsFilter.id
        : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );

    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);

      /*
       * Element already exists in the DOM:
       * update only its innerHTML.
       */
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const {
            className: previousElementClassName,
            id: previousElementId
          } = facetsToRender[index - 1];

          /*
           * Same facet type
           * (eg horizontal/vertical or drawer/mobile)
           */
          if (elementToRender.className === previousElementClassName) {
            const previousElement =
              document.getElementById(previousElementId);

            if (previousElement) {
              previousElement.after(elementToRender);
            }

            return;
          }
        }

        if (elementToRender.parentElement) {
          const parentElement = document.getElementById(
            elementToRender.parentElement.id
          );

          if (parentElement) {
            const firstFilter = parentElement.querySelector('.js-filter');

            if (firstFilter) {
              firstFilter.before(elementToRender);
            }
          }
        }
      }
    });

    /*
     * Active facets werden aktualisiert.
     *
     * Unsere sichtbaren Kategorie-Tags befinden sich nicht
     * in diesem Bereich, deshalb werden sie zusätzlich
     * in renderAdditionalElements() aktualisiert.
     */
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event && event.target) {
      const closestJSFilter = event.target.closest('.js-filter');

      if (closestJSFilter) {
        const closestJSFilterID = closestJSFilter.id;

        FacetFiltersForm.renderCounts(
          countsToRender,
          closestJSFilter
        );

        const mobileTarget = document.getElementById(
          closestJSFilterID
        );

        if (mobileTarget) {
          FacetFiltersForm.renderMobileCounts(
            countsToRender,
            mobileTarget
          );
        }

        const newFacetDetailsElement = document.getElementById(
          closestJSFilterID
        );

        if (newFacetDetailsElement) {
          const newElementSelector =
            newFacetDetailsElement.classList.contains(
              'mobile-facets__details'
            )
              ? '.mobile-facets__close-button'
              : '.facets__summary';

          const newElementToActivate =
            newFacetDetailsElement.querySelector(
              newElementSelector
            );

          const isTextInput =
            event.target.getAttribute('type') === 'text';

          if (newElementToActivate && !isTextInput) {
            newElementToActivate.focus();
          }
        }
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      '.active-facets-mobile',
      '.active-facets-desktop'
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) return;

      const currentElement = document.querySelector(selector);

      if (currentElement) {
        currentElement.innerHTML =
          activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    /*
     * Normale zusätzliche Elemente.
     */
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting'
    ];

    mobileElementSelectors.forEach((selector) => {
      const newElement = html.querySelector(selector);

      if (!newElement) return;

      const currentElement = document.querySelector(selector);

      if (currentElement) {
        currentElement.innerHTML = newElement.innerHTML;
      }
    });

    /*
     * ==========================================================
     * MOBILE KATEGORIE-TAGS
     * ==========================================================
     *
     * Das ist der entscheidende Teil für die mobile Darstellung.
     *
     * Die goldenen Tags befinden sich außerhalb des normalen
     * facet-filters-form. Deshalb werden sie von Dawn nicht
     * automatisch aktualisiert.
     *
     * Wir übernehmen hier nach jedem AJAX-Request die komplette
     * serverseitig neu gerenderte Version.
     *
     * Dadurch entscheidet Shopify anhand von value.active,
     * welcher Kategorie-Tag aktiv ist.
     */
    const newCategoryTags = html.querySelector(
      '.mobile-category-tags'
    );

    const currentCategoryTags = document.querySelector(
      '.mobile-category-tags'
    );

    if (newCategoryTags && currentCategoryTags) {
      currentCategoryTags.innerHTML =
        newCategoryTags.innerHTML;
    }

    /*
     * Falls der Container in der neuen HTML-Antwort vorhanden
     * ist, aber aktuell nicht existiert, wird er vor dem
     * Mobile-Filter eingefügt.
     */
    if (newCategoryTags && !currentCategoryTags) {
      const mobileFilterArea = document.querySelector(
        '.mobile-category-filter-area'
      );

      if (mobileFilterArea) {
        const clonedCategoryTags =
          newCategoryTags.cloneNode(true);

        mobileFilterArea.prepend(clonedCategoryTags);
      }
    }

    /*
     * Der Mobile-Filter muss nach dem HTML-Austausch seine
     * Events erneut binden.
     */
    const mobileFacetForm = document.getElementById(
      'FacetFiltersFormMobile'
    );

    if (mobileFacetForm) {
      const menuDrawer =
        mobileFacetForm.closest('menu-drawer');

      if (
        menuDrawer &&
        typeof menuDrawer.bindEvents === 'function'
      ) {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary =
      target.querySelector('.facets__summary');

    const sourceSummary =
      source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML =
        sourceSummary.outerHTML;
    }

    const targetHeaderElement =
      target.querySelector('.facets__header');

    const sourceHeaderElement =
      source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML =
        sourceHeaderElement.outerHTML;
    }

    const targetWrapElement =
      target.querySelector('.facets-wrap');

    const sourceWrapElement =
      source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector(
          'show-more-button .label-show-more.hidden'
        )
      );

      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => {
            hiddenItem.classList.replace(
              'hidden',
              'show-more-item'
            );
          });
      }

      targetWrapElement.outerHTML =
        sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList =
      target.querySelector('.mobile-facets__list');

    const sourceFacetsList =
      source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML =
        sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${
        searchParams && '?'.concat(searchParams)
      }`
    );
  }

  static getSections() {
    const productGrid = document.getElementById(
      'product-grid'
    );

    if (!productGrid) {
      return [];
    }

    return [
      {
        section: productGrid.dataset.id
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(
      searchParams,
      event
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms =
      document.querySelectorAll(
        'facet-filters-form form'
      );

    /*
     * Mobile Checkbox-Filter.
     */
    if (
      event.srcElement.className ===
      'mobile-facets__checkbox'
    ) {
      const form =
        event.target.closest('form');

      if (!form) return;

      const searchParams =
        this.createSearchParams(form);

      this.onSubmitForm(
        searchParams,
        event
      );

      return;
    }

    /*
     * Desktop / sonstige Filter.
     */
    const forms = [];

    const currentForm =
      event.target.closest('form');

    if (!currentForm) return;

    const isMobile =
      currentForm.id ===
      'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (
          form.id === 'FacetSortForm' ||
          form.id === 'FacetFiltersForm' ||
          form.id === 'FacetSortDrawerForm'
        ) {
          forms.push(
            this.createSearchParams(form)
          );
        }
      } else if (
        form.id ===
        'FacetFiltersFormMobile'
      ) {
        forms.push(
          this.createSearchParams(form)
        );
      }
    });

    this.onSubmitForm(
      forms.join('&'),
      event
    );
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FacetFiltersForm.toggleActiveFacets();

    const currentTarget =
      event.currentTarget;

    if (!currentTarget) return;

    const href =
      currentTarget.href || '';

    const url =
      href.indexOf('?') === -1
        ? ''
        : href.slice(
            href.indexOf('?') + 1
          );

    /*
     * Das funktioniert auch für unsere mobilen
     * Kategorie-Tags, obwohl sie außerhalb des
     * facet-filters-form liegen.
     */
    FacetFiltersForm.renderPage(
      url,
      null
    );
  }
}

FacetFiltersForm.filterData = [];

FacetFiltersForm.searchParamsInitial =
  window.location.search.slice(1);

FacetFiltersForm.searchParamsPrev =
  window.location.search.slice(1);

customElements.define(
  'facet-filters-form',
  FacetFiltersForm
);

FacetFiltersForm.setListeners();


class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.querySelectorAll('input').forEach(
      (element) => {
        element.addEventListener(
          'change',
          this.onRangeChange.bind(this)
        );

        element.addEventListener(
          'keydown',
          this.onKeyDown.bind(this)
        );
      }
    );

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(
      event.currentTarget
    );

    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;

    if (!event.key.match(pattern)) {
      event.preventDefault();
    }
  }

  setMinAndMaxValues() {
    const inputs =
      this.querySelectorAll('input');

    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (!minInput || !maxInput) return;

    if (maxInput.value) {
      minInput.setAttribute(
        'data-max',
        maxInput.value
      );
    }

    if (minInput.value) {
      maxInput.setAttribute(
        'data-min',
        minInput.value
      );
    }

    if (minInput.value === '') {
      maxInput.setAttribute(
        'data-min',
        0
      );
    }

    if (maxInput.value === '') {
      maxInput.setAttribute(
        'data-max',
        maxInput.getAttribute('data-max')
      );
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);

    const min = Number(
      input.getAttribute('data-min')
    );

    const max = Number(
      input.getAttribute('data-max')
    );

    if (value < min) {
      input.value = min;
    }

    if (value > max) {
      input.value = max;
    }
  }
}

customElements.define(
  'price-range',
  PriceRange
);


class FacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink =
      this.querySelector('a');

    if (!facetLink) return;

    facetLink.setAttribute(
      'role',
      'button'
    );

    facetLink.addEventListener(
      'click',
      this.closeFilter.bind(this)
    );

    facetLink.addEventListener(
      'keyup',
      (event) => {
        event.preventDefault();

        if (
          event.code.toUpperCase() ===
          'SPACE'
        ) {
          this.closeFilter(event);
        }
      }
    );
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest('facet-filters-form') ||
      document.querySelector(
        'facet-filters-form'
      );

    if (form) {
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define(
  'facet-remove',
  FacetRemove
);

